import React from 'react';
import PropTypes from 'prop-types';
import {
  openPdfWin,
  openUMSWin,
  openWindow,
  displayRelWkspc,
} from 'uxd-common-utilities';
import Icon from '../Icon/Icon';
import { createClassList } from '../../utils/dom/class';

import './Link.scss';

const Link = ({
  children,
  href,
  newWindow,
  utilityFunction,
  hideUnderline,
  attributes,
  onClick,
  configObj,
  classes,
}) => {
  const handleClick = (event) => {
    if (event && utilityFunction) {
      event.preventDefault();
    }

    if (utilityFunction === 'ums') {
      openUMSWin(
        configObj.id,
        configObj.winName,
        configObj.parms,
        configObj.width,
        configObj.height,
        configObj.left,
        configObj.top,
        configObj.pdf
      );
    } else if (utilityFunction === 'window') {
      openWindow(configObj);
    } else if (utilityFunction === 'pdf') {
      openPdfWin(
        configObj.url,
        configObj.winName,
        configObj.width,
        configObj.height
      );
    } else if (utilityFunction === 'relWkspc') {
      displayRelWkspc(
        configObj.appId,
        configObj.parmSet,
        configObj.authorizedUser
      );
    }
  };
  const handleKeyDown = (event) => {
    if (event.code === 'Enter') {
      handleClick();
    }
  };

  const defaultClasses = [
    'axiom-link', 'link',
    hideUnderline && 'axiom-link--hide-underline link__hide-underline',
    newWindow && 'axiom-link--new-window link__new-window',
  ].filter((className) => typeof className === 'string');

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      href={utilityFunction ? '' : href}
      className={createClassList({
        default: defaultClasses,
        custom: classes,
        required: [],
      })}
      target={newWindow ? '_blank' : null}
      rel='noopener noreferrer'
      onClick={utilityFunction ? handleClick : onClick}
      onKeyDown={handleKeyDown}
      {...attributes}
    >
      {children}
      {newWindow ? (
        <Icon name='new-window' seenByAssistiveTechnology />
      ) : (
        ''
      )}
    </a>
  );
};

Link.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  newWindow: PropTypes.bool,
  utilityFunction: PropTypes.oneOf([
    'window',
    'ums',
    'pdf',
    'relWkspc',
  ]),
  hideUnderline: PropTypes.bool,
  attributes: PropTypes.objectOf(PropTypes.any),
  onClick: PropTypes.func,
  configObj: PropTypes.objectOf(PropTypes.any),
  classes: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

Link.defaultProps = {
  newWindow: false,
  hideUnderline: false,
  attributes: {},
  onClick: undefined,
  utilityFunction: undefined,
  configObj: {},
  classes: [],
};

export default Link;
